import { ButtonUI } from 'sonata-react-components';

import './rowInfo.scss';

type Props = {
  id: string;
  title: string;
  subtitle?: string;
  description?: string;
  onClick?: () => void;
};

export function RowInfo({ id, title, subtitle, description, onClick }: Props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="rowInfo" key={id}>
      <div className="rowInfo__content">
        <span className="rowInfo__title">{title}</span>
        {subtitle && <span className="rowInfo__subtitle">{subtitle}</span>}
        {description && <span className="rowInfo__description">{description}</span>}
      </div>
      <ButtonUI
        className="rowInfo__button"
        icon="fa-duotone fa-regular fa-map-location-dot"
        onClick={handleClick}
        shape="link"
        size="small"
        type="secondary"
      />
    </div>
  );
}
